var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "onboardingEmail", staticClass: "listing-layout flex-column pb-8" },
    [
      _c("preloader", {
        staticClass: "preloader prelative",
        attrs: { background: false, display: _vm.loading }
      }),
      _vm._v(" "),
      _c("header", { staticClass: "flex-level mb-4 mt-1" }, [
        _c("h1", { staticClass: "m-0" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Email")))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "container-medium m-auto flex" },
          [
            _c(
              "el-collapse",
              {
                staticClass: "collapse-onboarding-mail m-auto",
                attrs: { accordion: "" },
                model: {
                  value: _vm.step,
                  callback: function($$v) {
                    _vm.step = $$v
                  },
                  expression: "step"
                }
              },
              [
                _c(
                  "el-collapse-item",
                  {
                    attrs: { name: 1 },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                        1/ " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Sélectionnez votre service email"
                                  )
                                ) +
                                "\n                        "
                            ),
                            _vm.provider
                              ? _c("span", { staticClass: "fs-3 regular" }, [
                                  _vm._v(_vm._s(_vm.provider.title))
                                ])
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("EmailOnboardingProvider", {
                      attrs: { successUrl: _vm.getSuccessUrl },
                      on: { validProvider: _vm.onValidProvider }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-collapse-item",
                  {
                    attrs: {
                      disabled:
                        !_vm.provider || _vm.isEmailEngineOtherProviderSelectd,
                      name: 2
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                        2/ " +
                                _vm._s(
                                  _vm.$l10n.__("Sélectionnez votre mode")
                                ) +
                                "\n                        "
                            ),
                            _vm.mode
                              ? _c("span", { staticClass: "fs-3 regular" }, [
                                  _vm._v(_vm._s(_vm.mode.title))
                                ])
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "EmailOnboardingMode",
                      _vm._b(
                        {
                          attrs: { provider: _vm.provider },
                          on: { validMode: _vm.onValidMode }
                        },
                        "EmailOnboardingMode",
                        _vm.params,
                        false
                      )
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-collapse-item",
                  {
                    attrs: {
                      disabled: _vm.isStepCheckingEmailDisabled,
                      name: 3
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                        3/ " +
                                _vm._s(
                                  _vm.$l10n.__("Vérifiez votre adresse email")
                                ) +
                                "\n                        "
                            ),
                            _vm.emailIsVerified &&
                            !_vm.isStepCheckingEmailDisabled
                              ? _c("span", { staticClass: "fs-3 regular" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.senderEmail) +
                                      " " +
                                      _vm._s(_vm.$l10n.__("(vérifié)")) +
                                      "\n                        "
                                  )
                                ])
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    !_vm.isStepCheckingEmailDisabled
                      ? _c("EmailOnboardingCheckEmail", {
                          attrs: { sentFromCorp: _vm.sentFromCorp },
                          on: {
                            onClickContinue: _vm.goToStep4,
                            onEmailSubmitted: _vm.onEmailSubmitted
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-collapse-item",
                  {
                    attrs: {
                      disabled:
                        !_vm.emailIsVerified || !_vm.isOtherProviderSelected,
                      name: 4
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "title",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n                        4/ " +
                                _vm._s(
                                  _vm.$l10n.__("Authentifiez votre domaine")
                                ) +
                                "\n                        "
                            ),
                            _c("span", { staticClass: "fs-3 regular" }, [
                              _vm._v(_vm._s(_vm.domain))
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("EmailOnboardingDomain", {
                      staticClass: "mx-5",
                      on: { validDomain: _vm.onValidDomain }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("CompassDialog", {
        staticClass: "onboarding-email",
        attrs: {
          visible: _vm.confirmationModal.active,
          size: "small",
          title: _vm.confirmationModal.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.confirmationModal, "active", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "dialog__default" }, [
                  _c("p", [_vm._v(_vm._s(_vm.confirmationModal.description))])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.confirmationModal.secondaryBtn.label,
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmationModal.secondaryBtn.action()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: { label: _vm.confirmationModal.primaryBtn.label },
                      on: {
                        click: function($event) {
                          return _vm.confirmationModal.primaryBtn.action()
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("SetUpProviderModal", {
        attrs: { isVisible: _vm.isSetUpProviderModalVisible },
        on: { close: _vm.handleCloseSetupProviderModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }